import { loginByUsername, loginByWeixin, wechatLogin, bindqywx } from '@/api/login'
import { checkReturnUrl } from '@/utils/main'

// 创建用户状态
const user = {
  state: {
    companySetting: null // 当前用户所属的公司设置
  },
  mutations: {
    set_user_companySetting (state, data) {
      state.companySetting = data
    }
  },
  actions: {
    // 用户名登录
    LoginByUsername ({ commit }, userInfo) {
      userInfo.username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(userInfo).then(response => {
          const data = response

          if (!data.errcode && (data.roles.length > 0 || data.userInfo.stationRole.length > 0)) {
            const loginResult = checkReturnUrl(data.userInfo)
            resolve(loginResult)
          } else {
            reject(data)
          }
        })
      })
    },
    // 微信/企业微信登录
    LoginByScan ({ commit }, code) {
      return new Promise((resolve, reject) => {
        if (code.appId === 'wx2530f941722a4c3e') {
          wechatLogin(code).then(response => {
            const data = response

            if (!data.errcode) {
              const loginResult = checkReturnUrl(data.userInfo)
              // 微信和企业微信返回的userId不同
              loginResult.scanUserId = data.userInfo.wxuserId
              loginResult.type = 'wx'
              resolve(loginResult)
            } else {
              reject(data)
            }
          })
        } else {
          loginByWeixin(code).then(response => {
            const data = response

            if (!data.errcode) {
              const loginResult = checkReturnUrl(data.userInfo)
              loginResult.scanUserId = data.userInfo.qyuserId
              loginResult.type = 'qy'
              resolve(loginResult)
            } else {
              reject(data)
            }
          })
        }
      })
    },
    // 绑定账号成功，并自动登录
    BindAndLogin ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        bindqywx(userInfo).then(response => {
          const data = response

          if (!data.errcode) {
            const loginResult = checkReturnUrl(data.userInfo)
            resolve(loginResult)
          } else {
            reject(data.errmsg)
          }
        })
      })
    }
  }
}

export default user
